<template>
    <!-- <div class="footer_black" style="background-color:#FFF">
        <div class="d-flex justify-space-between pa-8 footer_black align-center manage manage_font">
            <div class="sansation_title">Manage Listings</div>
            <v-icon @click="onCloseDeals">mdi-close-thick</v-icon>
        </div>

        <div v-if="!readyToLoadInquired" class="px-9">
            <v-card class="d-flex justify-center elevation-0" style="background-color:#FFF">
                <v-progress-circular indeterminate color="primary" class="my-12" size="40" width="3"></v-progress-circular>
            </v-card>
        </div>

        <div v-if="readyToLoadInquired && !interestListings.length" class="text-center mx-9 mt-9">
            <v-img :src="require(`@/assets/NoDealsMap.png`)" contain></v-img>
            <div class="d-block sansation_subtitle my-3">Oops, no deals yet</div>
            <div class="d-block my-6 mx-12">
                You haven't expressed interest on a Seller Listing yet. Find a listing and express interest to view and manage your deals.
            </div>
            <v-btn  
                color="primary" 
                class="text-capitalize sansation_subtitle my-9 align-center"
                @click="onCloseDeals"
                to="/buyer_listings">
                Go to listings
            </v-btn>
        </div> -->

        <div v-if="readyToLoadInquired && interestListings.length">
            <v-card
                v-for="(item, i) in interestListings"
                :key="i"
                style="border-bottom: 3px solid #EFEFEF"
                :style="disqualifiedBuyerStatusIds.includes(item.buyer_status_id) ? 'background-color:#F6F6F6' : 'background-color: white'"
                class="py-3 px-8"
            >
                <div class="align-center sansation footer_black">

                    <div v-if="disqualifiedBuyerStatusIds.includes(item.buyer_status_id) || item.is_archived" class="d-flex align-center">
                        <div class="d-inline my-3 align-center" style="max-width: 70%">
                            <div class="d-block align-center">
                                <a :href="`/buyer_listings/${item.listing_id}`" push class="general_lightgrey--text text--darken-4 sansation_subtitle no_listing_link">{{ item.listing_id }}</a>
                                <v-chip
                                    pill
                                    small
                                    class="ml-5 text-uppercase general_grey--text"
                                    color="general_lightgrey">
                                    {{ item.buyer_status }}
                                </v-chip>
                            </div>
                            <div class="d-block my-3 general_lightgrey--text text--darken-4" v-text="item.title"></div>                           
                        </div>
                        <v-spacer></v-spacer>
                        <div class="d-inline">
                            <div v-if="item.is_archived === false" class="d-inline px-9 py-2">
                                <a  class="general_grey--text remove_link text-capitalize sansation"
                                    style="font-size: 1.1rem !important"
                                    @click="updateListing('is_archived', item.id)">
                                    Archive Interest
                                </a>
                            </div>
                            <div v-else class="d-inline px-9 py-2">
                                <span class="general_grey--text text-capitalize sansation"
                                    style="font-size: 1.1rem !important">
                                    Archived
                                </span>
                            </div>
                        </div>
                    </div>

                    <div v-else>
                        <div class="d-flex my-3 align-center">
                            <div class="d-inline d-flex align-center">
                                <a :href="`/buyer_listings/${item.listing_id}`" push class="grow--text sansation_subtitle no_listing_link">{{ item.listing_id }}</a>
                                <v-chip
                                    pill
                                    small
                                    color="accent"
                                    class="ml-5 text-uppercase grow--text">
                                    {{ item.buyer_status }}
                                </v-chip>
                            </div>
                            <v-spacer></v-spacer>
                            <div class="d-inline text-right" style="max-width: 25%; min-width: 25%">LISTING STAGE</div>
                        </div>
                        
                        <div class="d-flex d-block my-3">
                            <div class="d-inline" style="max-width: 70%" v-text="item.title"></div>
                            <v-spacer></v-spacer>
                            <div class="d-inline text-right" style="max-width: 25%; min-width: 25%"><strong>{{ item.stage_name }}</strong></div>
                        </div>

                        <div class="mt-9 mb-6 d-flex d-block">
                            <!-- <v-btn 
                                :value="item.listing_id" 
                                outlined 
                                x-large 
                                color="#37383C" 
                                class="text-capitalize font-weight-bold sansation" 
                                style="background-color:#EFEFEF; border:2px solid #37383C"
                                @click="onDealDetail">
                                View Details
                            </v-btn> -->
                            <div class="d-inline">
                                <v-btn 
                                    outlined 
                                    large 
                                    color="primary" 
                                    class="sansation" 
                                    href="mailto:buyer@successionresourcegroup.com" 
                                    target="_blank">
                                    Request Update
                                </v-btn>
                            </div>
                            
                            <div v-if="item.is_archived === false" class="d-inline px-9 py-2">
                                <a  class="general_grey--text remove_link text-capitalize sansation"
                                    style="font-size: 1.1rem !important"
                                    @click="updateListing('is_archived', item.id)">
                                    Archive Interest
                                </a>
                            </div>
                            <div v-else class="d-inline px-9 py-2">
                                <span class="general_grey--text text-capitalize sansation"
                                    style="font-size: 1.1rem !important">
                                    Archived
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card>
        </div>
    <!-- </div> -->
</template>

<script>
    import axios from "axios";
import Cookie from "js-cookie";
    import appUrls from '../helpers/environment';
    import router from '../router';
    let dateFormat = require('dateformat');

    export default {
        name: 'ManageListings',
        props: [
            'closeDeals',
            'viewDealDetails',
            'manageId',
            'reloadListings'
        ],
        data () {
            return {
                listings: [],
                interestListings: [],
                readyToLoadInquired: false,
                listing_statuses: [
                    {   value: 1, text: 'Open' },
                    {   value: 2, text: 'Coming' },
                    {   value: 3, text: 'Pending' },
                    {   value: 4, text: 'Sold' },
                ],
                listing_stages: [],
                buyer_statuses: [],
                disqualifiedBuyerStatusIds: [],
            }
        },
        watch: {
            reloadListings () {
              this.getMyListings()
            }
        },

        created () {
            this.getLists()
            this.getDisqualifiedBuyerStatusIds()
        },

        mounted () {
            setTimeout(() => {
                this.getMyListings()
            }, 1500);
        },
        methods: {
            getDisqualifiedBuyerStatusIds: async function () {
                try {
                    const get_res = await axios.get(`${appUrls.api}/api/disqualified_ids`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })

                    if ( get_res.data.outcome ) {
                        this.disqualifiedBuyerStatusIds = get_res.data.disqualified_ids
                    }
                } catch ( err ) {
                    console.log(error);
                }
            },

            onCloseDeals: function () {
                this.$emit('closeDeals', !this.closeDeals)
            },
            
            onDealDetail: function (e) {
                this.$emit('closeDeals', !this.closeDeals)
                this.$emit('viewDealDetails', !this.viewDealDetails)
                this.$emit('manageId', e.currentTarget.value)
            },

            getMyListings: async function () {
                axios.post(`${appUrls.api}/api/listings`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    data: { 'user_id': Cookie.get('id') }
                })
                .then( res => {
                    if(res.data.outcome){
                        //console.log(res.data)
                        this.listings = res.data.listings;
                        let i = 0;
                        for( let listing of this.listings ) {
                            //this.listings[i].post_date    = dateFormat(listing.post_date, "mm/dd/yyyy");
                            this.listings[i].post_date      = this.listings[i].post_date.substr(0, 10);
                            this.listings[i].listing_type   = this.listings[i].listing_type != undefined ? parseInt(this.listings[i].listing_type) : 0;
                            this.listings[i].status         = this.listings[i].status != undefined ? parseInt(this.listings[i].status) : 0;
                            this.listings[i].stage          = this.listings[i].stage != undefined ? parseInt(this.listings[i].stage) : 0;

                            // AUM TEXT
                            // if (Number.parseFloat(this.listings[i].aum) >= 1000000) {
                            //     let aum_text = Number.parseFloat(this.listings[i].aum / 1000000).toFixed(1)
                            //     this.listings[i].aum_text = '$'+aum_text.replace(/\.?0*$/,'')+'M'
                            // }else{
                            //     this.listings[i].aum_text = toDollarsListings(Number.parseFloat(this.listings[i].aum))
                            // }

                            // REVENUE TEXT
                            // if (Number.parseFloat(this.listings[i].revenue) >= 1000000) {
                            //     let rev_text = Number.parseFloat(this.listings[i].revenue / 1000000).toFixed(1)
                            //     this.listings[i].rev_text = '$'+rev_text.replace(/\.?0*$/,'')+'M'
                            // }else{
                            //     this.listings[i].rev_text = toDollarsListings(Number.parseFloat(this.listings[i].revenue))
                            // }

                            // IMAGE
                            //this.listings[i].img = require(`@/assets/listings/states/${this.listings[i].state}.jpg`)

                            // STATUS TEXT
                            if ( this.listings[i].status != 0 ) {
                                let statusObj = this.listing_statuses.find(obj => parseInt(obj.value) === this.listings[i].status) || {};
                                this.listings[i].status_name = statusObj.text;
                            } else {
                                this.listings[i].status_name = "[Not Defined]";
                            }

                            // STAGE TEXT
                            if ( this.listings[i].stage != 0 ) {
                                let lStageObj = this.listing_stages.find(obj => parseInt(obj.value) == this.listings[i].stage);
                                this.listings[i].stage_name = lStageObj.text;
                            } else {
                                this.listings[i].stage_name = "[Not Defined]";
                            }
                            // TYPE NAME
                            // let typeObj = this.listing_types.find(obj => parseInt(obj.value) === this.listings[i].listing_type);
                            // this.listings[i].type_name = typeObj.text;

                            // LOOK TO SEE IF THERE IS EVEN ANY RECORDS IN jbuyerstolistings FOR THIS USER & LISTING
                            let has_record = res.data.actions.find(row => row.listing_id === this.listings[i].id) ? true : false;
                            let interest_record = has_record ? res.data.actions.find(row => row.listing_id === this.listings[i].id) : false;

                            // INTERESTED
                            //console.log('has_record: '+has_record)
                            this.listings[i].interested     = has_record ? interest_record.interest ? true : false : false;
                            this.listings[i].interest_type  = has_record ? interest_record.interest ? "error" : "primary" : "primary";
                            this.listings[i].interest_text  = has_record ? interest_record.interest ? "Retract Interest" : "Express Interest" : "Express Interest";

                            // this.listings[i].interest_toggle = has_record ? "notshow" : "show";
                            // this.listings[i].interest_type   = has_record ? "error" : "primary";
                            // this.listings[i].interest_text   = has_record ? "I'm Interested" : "Express Interest";

                            // OFFER
                            //console.log('interest_record.offer: '+interest_record.offer)
                            this.listings[i].offer_made = interest_record ? interest_record.offer ? true : false : false;
                            this.listings[i].offer_type = interest_record ? interest_record.offer ? "error" : "primary" : "primary";
                            this.listings[i].offer_text = interest_record ? interest_record.offer ? 'Offer Made' : 'Make An Offer' : 'Make An Offer';

                            // FAV
                            // this.listings[i].fav        = interest_record ? interest_record.fav ? true : false : false;
                            // this.listings[i].fav_color  = interest_record ? interest_record.fav ? "warning" : "#999" : "#999";

                            // BUYER STATUS
                            if (has_record) {
                                let listing_action = res.data.actions.find(act => act.listing_id == this.listings[i].id);
                                let bStatusObj = this.buyer_statuses.find(obj => parseInt(obj.value) == listing_action.status_id) || {};
                                this.listings[i].buyer_status = bStatusObj.text;
                                this.listings[i].buyer_status_id = listing_action.status_id;
                                this.listings[i].buyer_rank = listing_action.rank;
                                this.listings[i].is_archived = listing_action.is_archived;
                            }
                            i++;
                        }
                        // console.log(this.listings)
                        this.interestListings = this.listings.filter(row => {
                            return row.interested === true || row.offer_made === true
                        });

                        this.interestListings.sort((a, b) => (a.buyer_rank > b.buyer_rank) ? 1 : ((b.buyer_rank > a.buyer_rank) ? -1 : 0))
                        // console.log(this.interestListings)

                        this.interestListings.sort((x, y) => {
                            // true values first
                            // return (x.is_archived === y.is_archived) ? 0 : x.is_archived ? -1 : 1;
                            // false values first
                            return (x.is_archived === y.is_archived) ? 0 : x.is_archived ? 1 : -1;
                        });
                        
                        //console.log(this.interestListings)
                        this.readyToLoadInquired = true;
                        //console.log(this.readyToLoadInquired)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            getLists: function () {
                let optionsLists = [ 
                    {'name': 'listing_stages', 'type': 'txt'}, 
                    {'name': 'buyer_status', 'type': 'desc'} 
                ];
                
                axios.post(`${appUrls.api}/api/lists`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    list_options: optionsLists
                })
                .then( res => {
                    //console.log(res.data)
                    if(res.data.outcome){
                        let arrLists = res.data.lists;
                        // SET PROPERTIES WITH THIER APPROPRIATE LIST
                        for (let l in arrLists) {
                            if (arrLists[l].name == 'buyer_status') this.buyer_statuses = arrLists[l].list
                            if (arrLists[l].name == 'listing_stages') this.listing_stages = arrLists[l].list
                        }
                        //console.log('listing_stages', this.listing_stages)
                        // console.log('buyer_status', this.buyer_statuses)
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            async updateListing (action, lid) {
                axios.post(`${appUrls.api}/api/update_listing`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    data: {
                        'user_id': Cookie.get('id'),
                        'listing_id': lid,
                        'action': action,
                    }
                })
                .then(res => {
                    if (res.data.outcome) {
                        this.readyToLoadInquired = false;
                        setTimeout(() => {
                            this.getMyListings()
                        }, 1500);
                    } else {

                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
            },
        }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .sansation_lg_title {
        font-family: 'Sansation';
        font-size: 2.2rem!important;
    }
    .manage {
        border-bottom: 1px solid #5F6062;
    }
    .manage_font {
        font-size: 1.1rem !important;
        font-weight: 600;
        /* letter-spacing: .03125em !important; */
        color: #5F6062;
    }

    .v-application .no_listing_link {
        color: #5F6062;
    }

    .v-application .listing_link {
        text-decoration-line: none;
        color: #5F6062;
    }

    .v-application .listing_link:hover {
        text-decoration-line: none;
        color: black;
    }

    /* .remove_link {
        text-decoration-line: underline;
    } */
    .remove_link:hover{
        text-decoration-line: underline;
    }

    .v-application .active_link {
        text-decoration-line: none;
        font-weight: 800;
        color: #0096A6;
        border-bottom: 5px solid #0096A6;
    }
</style>


// WEBPACK FOOTER //
// src/components/ManageListings.vue